<div #schema class="overflow-hidden border w-full h-full cursor-grab active:cursor-grabbing"></div>
<div class="-mt-10">
  <button mat-icon-button (click)="zoom(2)"><mat-icon>zoom_in</mat-icon></button>
  <button mat-icon-button (click)="zoom(0.5)"><mat-icon>zoom_out</mat-icon></button>
  <button mat-icon-button (click)="resetZoomClickHandler()"><mat-icon>zoom_out_map</mat-icon></button>
</div>
